// extracted by mini-css-extract-plugin
export default {"removeButton":"NewsCard_removeButton__vpp5w"};